export default {
  columns: {
    offerName: 'Nazwa oferty',
    type: 'Typ',
    status: 'Status',
    active: 'Aktywna',
    inactive: 'Nieaktywna',
    details: 'Szczegóły',
    schedule: 'Harmonogram',
    startDate: 'Data rozpoczęcia',
    images: 'Zdjęcie',
  },
  actions: {
    edit: 'Edytuj',
    rename: 'Zmień nazwę',
    delete: 'Usuń',
    set_active: 'Ustaw jako aktywną',
    set_inactive: 'Ustaw jako nieaktywną',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    activate: 'Zastąp i aktywuj',
    manage_images: 'Edytuj zdjęcie',
  },
  toasts: {
    offer_enabled: '{{offer}} jest teraz aktywną ofertą dla {{for}}',
    offer_disabled: '{{offer}} ustawiona jako nieaktywna.',
    update_failed: 'Aktualizacja oferty nie powiodła się.',
    successfully_deleted: 'Oferta została pomyślnie usunięta',
    delete_failed: 'Usunięcie oferty nie powiodło się',
  },
  title: 'Zarządzaj wszystkimi ofertami',
  popups: {
    delete: {
      title: 'Czy na pewno chcesz usunąć tę ofertę?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Zastępowanie ofert głównych jest niedozwolone',
      title: 'Zastąpić aktywną ofertę na ten okres?',
      description:
        'Aktywujesz {{offer}} w {{weekday}}{{between}}. Spowoduje to dezaktywację bieżącej aktywnej oferty {{currentOffer}} dla tego samego okresu.',
      between: ', między {{start}}-{{end}}',
    },
  },
};
